export const toggleMandatory = <T extends { isMandatory?: 0 | 1 }>(list: T[], index: number): T[] =>
  list.map((item, idx) => (idx === index ? { ...item, isMandatory: item.isMandatory === 1 ? 0 : 1 } : item));
